import { UserShape } from "~shapes/user"
import { ProofOfOwnership } from "~shapes/proofOfOwnership"
import {
  PROOF_OF_OWNERSHIP_STATUS,
  PROOF_OF_OWNERSHIP_VERSIONS,
} from "~constants/proofOfOwnership"

export const userInitialState: UserShape = {
  createdAt: "",
  email: "",
  id: "",
  profile: {
    annualIncomeRange: "",
    createdAt: "",
    firstName: "",
    gender: "",
    lastName: "",
    name: "",
    phoneNumber: "",
    receiveMail: false,
    receiveText: false,
    updatedAt: "",
    yearOfBirth: "",
    zipCode: "",
  },
  registrationCompleted: false,
  shippingAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    country: "US",
    id: "",
    phoneNumber: "",
    postal: "",
    state: "",
  },
  status: "",
  updatedAt: "",
}

export const PooInitialState: ProofOfOwnership = {
  broker: "",
  created_at: "",
  id: "",
  name: "",
  state: PROOF_OF_OWNERSHIP_STATUS.CREATED,
  user_id: "",
  version: PROOF_OF_OWNERSHIP_VERSIONS.SECOND,
}
